var e = function(n) {
  return n == null;
};
export {
  e as i
};
